/* global gigya */

import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

const INVALID_FORM_GIGYA_ERROR_CODES = [403042, 403043]
const INVALID_FORM_ERROR_TRACKING_CONTEXT = 'gigya screens modal invalid username or password'
const GENERIC_ERROR_TRACKING_CONTEXT = 'gigya screens modal generic'

const NotifyToGigya = ({loginConfig, onAuthentication = () => {}, onScreenFinished = () => {}, origin}) => {
  const {domain} = useContext(Context)
  const {track} = useAnalyticsTrack()

  useMount(() => {
    handleGigyaLoaded()
  })

  const handleOnGigyaLogin = async gigyaResponse => {
    if (gigyaResponse.errorCode) {
      const errorContext = INVALID_FORM_GIGYA_ERROR_CODES.includes(gigyaResponse.errorCode)
        ? INVALID_FORM_ERROR_TRACKING_CONTEXT
        : GENERIC_ERROR_TRACKING_CONTEXT

      const trackingErrorEvent = await domain.get('get_event_tracking_data_use_case').execute({
        event: 'Signed In Error',
        origin,
        context: errorContext
      })

      track(trackingErrorEvent)
    } else {
      // check if the gigya returned user exists in our DB
      const [checkUserError, userExists] = await domain
        .get('check_gigya_user_exists_user_use_case')
        .execute({gigyaResponse})

      if (checkUserError) {
        console.error(checkUserError)
        onScreenFinished()
        return
      }

      const isNewUser = !userExists

      // overwrite newUser in gigyaResponse
      gigyaResponse.newUser = isNewUser
      onAuthentication({gigyaResponse, isNewUser})
      onScreenFinished()
    }
  }

  const handleGigyaLoaded = () => {
    gigya.socialize.notifyLogin({
      ...loginConfig,
      callback: handleOnGigyaLogin,
      sessionExpiration: 2
    })
  }

  return null
}

NotifyToGigya.displayName = 'NotifyToGigya'
NotifyToGigya.propTypes = {
  loginConfig: PropTypes.object.isRequired,
  onAuthentication: PropTypes.func,
  onScreenFinished: PropTypes.func,
  origin: PropTypes.string
}

export default NotifyToGigya
